import groupplaceholder from '@/assets/images/groupplaceholder.png'
import userProfileBroken from '@/assets/images/user-profile-broken.png'
import shareLink from '@/assets/images/share-link.png'
import shareWhatsApp from '@/assets/images/share-whatsapp.png'
import shareTelegram from '@/assets/images/share-telegram.png'
import shareFacebook from '@/assets/images/share-facebook.png'
import shareLinkedIn from '@/assets/images/share-linkedin.png'

// Vuex
import { mapState, mapActions } from 'vuex'

// Utilitários
import { valueToTime, canAddUserShift } from '@/functions'

// Components
import DailyReport from './components/dailyReport'
import GroupTab from '@/components/GroupTab'
import InfoCard from './InfoCard'

import SosButton from '@/components/SosButton'
import SosSelect from '@/components/SosSelect'

import ConfirmDialog from '@/modals/ConfirmDialog'

import ScaleCreate from '@/modals/ScaleCreate'
import ScaleEdit from '@/modals/ScaleEdit'
import GroupEditModal from '@/modals/GroupEditModal'
import SubscriptionModal from '@/modals/SubscriptionModal'
import DialogTransferMasterModal from '@/modals/DialogTransferMaster'
/*
// [staging-portaltelemedicina / master-portaltelemedicina]
import AttachMunicipalityToUserModal from '@/modals/AttachMunicipalityToUserModal'
// [staging-portaltelemedicina / master-portaltelemedicina]
*/

import ExportGroupUsersModal from '@/modals/reports/ExportGroupUsersModal'
import ExportTimesheetModal from '@/modals/reports/ExportTimesheetModal'
import ExportTimesheetSimulationModal from '@/modals/reports/ExportTimesheetSimulationModal'
import ExportPayrollModal from '@/modals/reports/ExportPayrollModal'
import ShareScaleConfigModal from '@/modals/ShareScaleConfigModal';

import SosCurrentPlanBadge from '@/components/SosCurrentPlanBadge'

import WorkingHoursRulesModal from '@/modals/WorkingHoursRulesModal'

// API
import {
  apiDeleteScale,
  apiRenewScaleLink,
  apiRenewGroupLink,
  getUserByID,
  /*
  // [staging-portaltelemedicina / master-portaltelemedicina]
  apiGetScaleConsultationDuration,
  // [staging-portaltelemedicina / master-portaltelemedicina]
  */
} from '@/services/firebase'
import { getUserUID } from '@/services/endpoints/session'
import {
  apiSetGroupUserLevel,
  apiRemoveUserFromGroup,
  apiCheckUserInGroup,
  apiAttachScaleToGroupUser,
  apiDetachScaleFromGroupUser,
  /*
  // [staging-portaltelemedicina / master-portaltelemedicina]
  apiUpdateGroupUserMunicipalityRole,
  apiAttachMunicipalityToGroupUser,
  apiDettachMunicipalityFromGroupUser,
  // [staging-portaltelemedicina / master-portaltelemedicina]
  */
} from '@/services/endpoints/groups'
import { apiSetWaitingDutyStatus } from '@/services/duties'

// Mixins
import confirmDialogMixin from '@/mixins/cd.mixin.js'
import stringMixin from '@/mixins/string.mixin.js'
import SubscriptionModalMixin from '@/mixins/subscription.modal.mixin'

// Constants
import {
  freeVersion,
  whiteLabel,

  // Base URL to generate GROUP USERS REPORT
  reportUrl,
  // User capabilities
  GRUPO_ALTERAR_DETALHES_DA_ESCALA, GRUPO_EDITAR_DETALHES, GRUPO_CONVIDAR_USUARIO, GRUPO_NOVA_ESCALA, GRUPO_GERAR_FOLHA_DE_PONTO, GRUPO_SIMULAR_FOLHA_DE_PONTO, GRUPO_FOLHA_DE_PAGAMENTO, GRUPO_VER_TODOS_OS_PLANTOES, GRUPO_COMPARTILHAR_TODOS_OS_PLANTOES, GRUPO_CRIAR_ESCALA, GRUPO_ACOMPANHAR_ESCALA,
  ESCALA_APAGAR, ESCALA_RENOVAR_LINK, ESCALA_COMPARTILHAR, ESCALA_RETIRAR_USUARIO, ESCALA_ALTERAR_PAPEL, ESCALA_VER_PLANTOES_DO_USUARIO, EXPORT_OPERATIONAL_REPORT, GRUPO_VER_USUARIOS, GRUPO_VER_VALORES
} from '@/constants'

// Moment JS
import moment from 'moment'
import 'moment/locale/pt-br'

import MessageModal from '@/modals/MessageModal'

import * as types from '@/store/working-hours-rules/types.js'

import {
  MEMBER_USER_ROLE,
  MANAGER_USER_ROLE,
  MASTER_USER_ROLE,
  MEMBER_USER_ROLE_NAME,
  MANAGER_USER_ROLE_NAME,
  MASTER_USER_ROLE_NAME
} from '@/constants/userRoles';

import {
  RULE_ACTION_LABELS,
  RULE_LEVEL_LABELS,
  RULE_TYPE_LABELS,
  RULE_TYPE_MAX_CONSECUTIVE_WORK_DAYS
} from '@/constants/workRules'

import ExportOperationalModal from '@/modals/reports/ExportOperationalModal'
import { apiUpdateScaleOrder } from '@/services/groups'

const SEARCH_MIN_LENGTH = 3

// const itemsPerPage = 10
const visiblePages = 5

//
//
//

export default {
  name: 'GroupScales',

  components: {
    /*
    // [staging-portaltelemedicina / master-portaltelemedicina]
    "attach-municipality-to-user-modal": AttachMunicipalityToUserModal,
    // [staging-portaltelemedicina / master-portaltelemedicina]
    */
    'export-group-users-modal': ExportGroupUsersModal,
    'group-tab': GroupTab,
    'export-payroll-modal': ExportPayrollModal,
    'daily-report': DailyReport,
    ScaleEdit,
    'confirm-dialog': ConfirmDialog,
    'export-timesheet-modal': ExportTimesheetModal,
    'export-timesheet-simulation-modal': ExportTimesheetSimulationModal,
    'group-edit-modal': GroupEditModal,
    'sos-button': SosButton,
    'info-card': InfoCard,
    'scale-create': ScaleCreate,
    'sos-select': SosSelect,
    'sos-current-plan-badge': SosCurrentPlanBadge,
    'subscription-modal': SubscriptionModal,
    'working-hours-rules-modal': WorkingHoursRulesModal,
    'message-modal': MessageModal,
    'export-operational-report-modal': ExportOperationalModal,
    'share-scale-config-modal': ShareScaleConfigModal,
    'dialog-transfer-master-modal': DialogTransferMasterModal,
  },

  mixins: [
    confirmDialogMixin,
    stringMixin,
    SubscriptionModalMixin,
  ],

  data () {
    return {
      //
      //
      //

      SHOW_SEARCH_HINT: false,

      // --- Search

      // Isso elimina race condition.
      // ✔ Busca antiga não sobrescreve nova
      // ✔ Paginação rápida não gera glitch
      // ✔ Troca rápida de abas não quebra estado
      currentSearchRequestId: 0,

      // Informação acima do campo de busca a fim de evitar certos glitches que aconteciam no layout
      searchResultText: "",

      // Termos de busca
      searchQuery: '',
      debouncedSearch: "",

      // --- Pagination

      currentPage: 1,
      itemsPerPage: 10,

      //
      // Necessário para controlar a UI e a alteração de listas nas colunas
      //

      usersLoadingStatus: {},

      //
      //
      //

      freeVersion,
      whiteLabel,

      actionLoading: false,

      shareShiftsVisible: false,

      sheet: false,
      sharedScaleItem: null,

      groupTab: 'escalas',

      shareTelegram,
      shareLink,
      shareWhatsApp,
      shareLinkedIn,
      shareFacebook,

      loadingReport: 'WAITING',

      btnState: {
        folhaDePagamento: false,
      },

      workingHoursModal: {
        active: false,
        level: null,
        entityId: null,
      },
      transferMasterModal: {
        active: false,
        groupID: null,
        currentMasterUserID: null,
      },
      draggedItem: null,
      loggedUserIsMaster: false,
    }
  },

  computed: {
    ...mapState({
      userSession: state => state.app.userSession,
      group: state => state.app.group,
      groups: state => state.app.groups,
      currentGroupCapabilities: state => state.app.currentGroupCapabilities,
      plans: state => state.app.plans,
      listeners: state => state.app.listeners,
      groupUsers: state => state.app.groupUsers,
      /*
      // [staging-portaltelemedicina / master-portaltelemedicina]
      groupMunicipalities: state => state.app.groupMunicipalities,
      // [staging-portaltelemedicina / master-portaltelemedicina]
      */
      participantsCount: state => state.app.listeners.participantsCount,
      totalUsers: state => state.app.totalUsers,
      groupUsersItemsPerPage: state => state.app.groupUsersItemsPerPage,
      workingHoursRulesByGroup: state => state.workingHoursRules.rulesByGroup,
      groupScales: state => state.app.groupScales,
      groupRequestedShifts: state => state.app.groupRequestedShifts,
      // loadingGroupStatistics: state => state.app.loadingGroupStatistics,
      // numberOfAvailableDutys: state => state.app.numberOfAvailableDutys,
    }),

    //
    // O USUÁRIO ESTÁ PESQUISANDO
    //

    isModeSearch() {
      return this.searchQuery.trim().length >= SEARCH_MIN_LENGTH
    },

    //
    //
    //

    preparedUsers()
    {
      if (!Array.isArray(this.groupUsers)) return []

      // const municipalities = this.groupMunicipalities?.filter(u => u.isMunicipality && u.isAdmin) || []

      /*
      // [staging-portaltelemedicina / master-portaltelemedicina]
      // Será que é possível algum item em groupMunicipalities não ser município? Checar depois, mas é certeza que todos são
      const municipalities = this.groupMunicipalities || []
      // [staging-portaltelemedicina / master-portaltelemedicina]
      */

      const scales = this.groupScales || []

      return this.groupUsers.map(user => {
        /*
        // [staging-portaltelemedicina / master-portaltelemedicina]
        const userMunicipalities = user.userMunicipalities ? Object.keys(user.userMunicipalities) : []

        const attachedMunicipalities = municipalities.filter(x => userMunicipalities.includes(x.userID)).map(m => m.userName || m.userID)
        const attachedMunicipalitiesText = attachedMunicipalities.length === 0 ? "Todos" : (
          attachedMunicipalities.length === 1 ? attachedMunicipalities[0] : `(${attachedMunicipalities.length}) ${attachedMunicipalities.join(', ')}`
        )
        // [staging-portaltelemedicina / master-portaltelemedicina]
        */

        // (DESCONTINUADO) Lista de municípios para SOS-SELECT
        /* const municipalityItems = municipalities.map(m => ({
          key: `municipality_${m.userID}_${user.userID}`,
          value: m.userID,
          text: m.userName || m.userID,
          rawText: m.userName || m.userID,
          checked: userMunicipalities.includes(m.userID),
          payload: {
            municipalityID: m.userID,
            managerID: user.userID
          }
        })) */

        const scaleItems = scales.map(scale => {
          const checked = scale.scaleRelatedUsers?.includes(user.userID)

          return {
            key: `user_scale_${user.userID}_${scale.scaleID}`,
            // value: scale.scaleID,
            value: `${user.userID}_${scale.scaleID}`,
            rawText: scale.scaleName || scale.scaleID,
            text: scale.scaleName || scale.scaleID,
            checked,
            payload: {
              checked,
              userID: user.userID,
              userName: user.userName,
              scaleID: scale.scaleID,
            }
          }
        })

        return {
          ...user,
          userImage: user.userImage || userProfileBroken,
          roleName: user.role === "MASTER" ? "Master" : (user.role === "ADMIN" ? "Gestor" : "Membro"),
          /*
          // [staging-portaltelemedicina / master-portaltelemedicina]
          attachedMunicipalitiesText,
          // municipalityItems,
          // [staging-portaltelemedicina / master-portaltelemedicina]
          */
          scaleItems
        }
      })
    },

    //
    //
    //

    /* showFoundUsers () {
      return this.totalUsers > 0 && this.listeners.loadingGroupUsers === false
    }, */

    /* hasGroupUsers () {
      return this.participantsCount > 0
    }, */

    isGroupUsersLoading () {
      return this.listeners.loadingGroupUsers
    },

    //
    //
    //
    // PAGINATION
    //
    //
    //

    // Cálculo da paginação com base nos itens filtrados
    // paginatedResults () {
    //   const start = (this.currentPage - 1) * this.groupUsersItemsPerPage
    //   const end = start + this.groupUsersItemsPerPage
    //   return this.filteredItems.slice(start, end)
    // },

    // Total de páginas com base nos itens filtrados
    totalPages () {
      return Math.ceil(this.totalUsers / this.itemsPerPage)
    },

    pageNumbers () {
      const pages = []
      const startPage = Math.max(1, this.currentPage - Math.floor(visiblePages / 2))
      const endPage = Math.min(this.totalPages, startPage + visiblePages - 1)

      // Adiciona as páginas no intervalo
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i)
      }

      // Adiciona o início e o fim das páginas, se necessário
      if (startPage > 1) {
        pages.unshift('...')
        pages.unshift(1)
      }

      if (endPage < this.totalPages) {
        pages.push('...')
        pages.push(this.totalPages)
      }

      return pages
    },

    //
    //
    //

    infoGroupUsersCountObj () {
      return {
        description: 'Participantes',
        icon: 'mdi-account-group',
        value: this.participantsCount,
        loading: this.isGroupUsersLoading,
      }
    },

    info3Obj () {
      return {
        description: 'Realizando plantões no grupo',
        icon: 'mdi-account',
        value: !!this.listeners === true && this.listeners.loadingGroupScales === 'no' ? this.listeners.numberOfPlantonistasOnGroup : 0,
        loading: !!this.listeners === true && this.listeners.loadingGroupScales !== 'no',
      }
    },

    //
    //
    //

    canAttachUserScales () {
      return this.freeVersion === true || this.userSession.userCapabilities.relacionarEscalas === true
    },

    // const talkToOurSupport = `<a href="https://api.whatsapp.com/send?phone=5513992061010&text=Olá, estou no ${planName} e não consigo vincular escalas a um plantonista. Preciso de ajuda." target="_blank">suporte</a>`
    // const textSupport = `<p>Por favor, verifique a situação do seu plano com o nosso ${talkToOurSupport}.</p>`
    // const textSupport = '<br /><span style="color: yellow">Por favor, verifique a situação do seu plano com o nosso suporte.</span>'

    canAttachUserScalesMessage ()
    {
      let title = ''
      let message = ''
      const planName = this.userSession.planName.name

      if (this.userSession.planOrigin === 'CUSTOM') {
        // Plano personalizado
        title = 'Verifique seu plano:'
        message = `Você está no ${planName} personalizado e não tem permissão para vincular escalas a um plantonista.`
      } else if (this.userSession.planOrigin === 'COUPON') {
        // Cupom ativo
        title = 'Verifique seu plano:'
        message = `Você tem um cupom ativo no ${planName}, mas não tem permissão para vincular escalas a um plantonista.`
      } else if (this.userSession.planOrigin === 'VINDI' && this.userSession.vindi.paymentStatus === 'paid') {
        // Assinatura ativa na vindi
        title = 'Faça um upgrade:'
        message = `Você está no ${planName}. Assine o Plano Platinum para conseguir vincular escalas a um plantonista.`
      } else if (this.userSession.planOrigin === 'VINDI' && this.userSession.vindi.paymentStatus !== 'paid') {
        // Assinatura ativa, mas com alguma pendência ou erro na vindi
        title = 'Verifique sua assinatura:'
        message = `Você não tem permissão para vincular escalas a um plantonista, pois você é assinante do ${planName} e ele não está ativo.`
      }
      else
      {
        if (!!this.userSession.vindi === true) {
          // Plano da vindi expirado
          title = 'Verifique sua assinatura:'
          message = `Você não tem permissão para vincular escalas a um plantonista, pois você assinou o ${this.userSession.vindi.planName.name} e ele expirou. Agora você está no ${planName}.`
        } else {
          // Plano gratuíto ou alcançou alguma condição desconhecida
          title = 'Verifique seu plano:'
          message = `Você está no ${planName} e não tem permissão para vincular escalas a um plantonista.`
        }
      }

      return this.canAttachUserScales ? '<span style="font-size: 16px; line-height: 20px">Você pode informar as escalas de um plantonista!</span>' : `<div style="line-height: 0"><div style="margin-bottom: 5px; font-size: 16px; font-weight: bold; line-height: 20px"><i aria-hidden="true" class="mdi mdi-information" style="display: inline-block; vertical-align: top; font-size: 20px"></i>&nbsp;${title}</div><span style="color: #fafad2; font-size: 16px; line-height: 20px">${message}</span></div>`
    },

    canAttachUserScalesStyles ()
    {
      return this.canAttachUserScales ? 'rgba(0, 139, 0, 0.95)' : 'rgba(139, 0, 0, 0.95)'
    },

    //
    // LOADING BAR STEP
    //

    loadingProgress: function () {
      if (!!this.listeners === false || !!this.listeners.loadingGroupDetails === false || !!this.listeners.loadingGroupScales === false || !!this.listeners.loadingRequestedShifts === false) return 0

      let progress = 0

      if (this.listeners.loadingGroupDetails === 'no') progress += 33.333333
      if (this.listeners.loadingGroupScales !== 'yes') progress += 33.333333
      if (this.listeners.loadingRequestedShifts !== 'yes') progress += 33.333333

      return progress
    },

    //
    //
    //

    groupStatistics: function ()
    {
      if (!!this.listeners === false) return []

      const availableShiftsCount = this.listeners.availableShiftsCount || 0
      const ownedShiftsCount = this.listeners.ownedShiftsCount || 0
      const participantsCount = this.listeners.participantsCount || 0

      return [
        {
          id: 1,
          type: 'info',
          description: `${availableShiftsCount === 1 ? 'Plantão vazio' : 'Plantões vazios'}`,
          icon: 'mdi-calendar-alert',
          value: availableShiftsCount,
        },
        {
          id: 2,
          type: 'info',
          description: `${ownedShiftsCount === 1 ? 'Plantão assumido' : 'Plantões assumidos'}`,
          icon: 'mdi-calendar-check',
          value: ownedShiftsCount,
        },
        {
          id: 3,
          type: 'info',
          description: `${participantsCount === 1 ? 'Participante' : 'Participantes'}`,
          icon: 'mdi-account-multiple',
          value: participantsCount,
        },
      ]
    },

    //
    //
    //
    //
    //
    //
    //

    hasWaitingDuties () {
      if (!!this.groupRequestedShifts === false || (!!this.groupRequestedShifts === true && !Array.isArray(this.groupRequestedShifts))) {
        return false
      }

      return this.groupRequestedShifts.length > 0
    },

    visibleGroupScales ()
    {
      const viewerID = String(this.userSession?.uid || "")

      if (
        !this.groupScales ||
        !Array.isArray(this.groupScales) ||
        this.groupScales.length === 0 ||
        !this.$route.params.groupID ||
        !viewerID
      ) {
        return []
      }

      if (this.VIEWER_GROUP_LEVEL === "MASTER") {
        return this.groupScales
      }

      const userHasRelatedScales = this.groupScales.filter(scale =>
        Array.isArray(scale.scaleRelatedUsers) && (scale.scaleRelatedUsers || []).includes(viewerID)
      )

      return userHasRelatedScales.length > 0 ? userHasRelatedScales : this.groupScales
    },

    haveScales () {
      return !!this.visibleGroupScales === true && Array.isArray(this.visibleGroupScales) && this.visibleGroupScales.length > 0
    },

    groupImage () {
      return this.$store.state.app.group.img || groupplaceholder
    },

    //
    // PERMISSIONS
    //

    groupActions () {
      const actions = []
      if (this.currentGroupCapabilities) {
        if (this.currentGroupCapabilities[GRUPO_CONVIDAR_USUARIO]) {
          actions.push({ id: 'TITLE', title: 'Usuários' })

          actions.push({ id: 'INVITE_USER', icon: 'mdi-account-plus', title: 'Convidar usuário' })
        }
        if (this.currentGroupCapabilities[GRUPO_NOVA_ESCALA]) {
          actions.push({ id: 'TITLE', title: 'Escalas' })
          actions.push({ id: 'NEW_SCALE', icon: 'mdi-calendar-plus', title: 'Nova escala' })
        }
        if (this.currentGroupCapabilities[GRUPO_GERAR_FOLHA_DE_PONTO] || this.currentGroupCapabilities[GRUPO_SIMULAR_FOLHA_DE_PONTO] || this.currentGroupCapabilities[GRUPO_FOLHA_DE_PAGAMENTO]) actions.push({ id: 'TITLE', title: 'Relatórios' })
        if (this.currentGroupCapabilities[GRUPO_GERAR_FOLHA_DE_PONTO]) actions.push({ id: 'EXPORT_TIMESHEET', icon: 'mdi-account-clock-outline', title: 'Gerar registro check in/out' })
        if (this.currentGroupCapabilities[GRUPO_SIMULAR_FOLHA_DE_PONTO]) actions.push({ id: 'EXPORT_TIMESHEET_SIMULATION', icon: 'mdi-timer-refresh-outline', title: 'Simular registro check in/out' })
        if (this.currentGroupCapabilities[GRUPO_FOLHA_DE_PAGAMENTO]) actions.push({ id: 'EXPORT_PAYROLL', icon: 'mdi-account-cash', title: 'Folha de pagamento' })
        if (this.currentGroupCapabilities[EXPORT_OPERATIONAL_REPORT]) actions.push({ id: 'EXPORT_OPERATIONAL_REPORT', icon: 'mdi-file-chart', title: 'Gerar relatório operacional' })
        if (this.currentGroupCapabilities[GRUPO_VER_TODOS_OS_PLANTOES] || this.currentGroupCapabilities[GRUPO_COMPARTILHAR_TODOS_OS_PLANTOES]) actions.push({ id: 'TITLE', title: 'Plantões' })
        if (this.currentGroupCapabilities[GRUPO_VER_TODOS_OS_PLANTOES]) actions.push({ id: 'GROUP_SHIFTS_SHOW', icon: 'mdi-magnify', title: 'Ver todos os plantões' })
        if (this.currentGroupCapabilities[GRUPO_VER_TODOS_OS_PLANTOES]) actions.push({ id: 'CREATE_SERIES', icon: 'mdi-content-duplicate', title: 'Criar série de itens' })
        if (this.currentGroupCapabilities[GRUPO_COMPARTILHAR_TODOS_OS_PLANTOES]) actions.push({ id: 'GROUP_LINK_RENEWAL_CODE', icon: 'mdi-refresh', title: 'Renovar link do grupo' })
        if (this.currentGroupCapabilities[GRUPO_COMPARTILHAR_TODOS_OS_PLANTOES]) actions.push({ id: 'GROUP_SHIFTS_SHARE', icon: 'mdi-share-variant-outline', title: 'Compartilhar todos os plantões' })
        if (this.currentGroupCapabilities[GRUPO_COMPARTILHAR_TODOS_OS_PLANTOES]) actions.push({ id: 'GROUP_SHIFTS_SHARE_CUSTOM', icon: 'mdi-share-variant', title: 'Compartilhar todos os plantões (personalizado)' })
        if (this.currentGroupCapabilities[GRUPO_VER_TODOS_OS_PLANTOES]) actions.push({ id: 'TITLE', title: 'Configurações' })
        if (this.currentGroupCapabilities[GRUPO_VER_TODOS_OS_PLANTOES]) actions.push({ id: 'SET_WORKING_HOURS_GROUP', icon: 'mdi-clock-outline', title: 'Configurar carga horária máxima de trabalho' })

        }
      return actions
    },

    permissaoAcoesDoGrupo () {
      if (this.currentGroupCapabilities) {
        return this.currentGroupCapabilities[GRUPO_CONVIDAR_USUARIO] ||
          this.currentGroupCapabilities[GRUPO_NOVA_ESCALA] ||
          this.currentGroupCapabilities[GRUPO_GERAR_FOLHA_DE_PONTO] ||
          this.currentGroupCapabilities[GRUPO_SIMULAR_FOLHA_DE_PONTO] ||
          this.currentGroupCapabilities[GRUPO_FOLHA_DE_PAGAMENTO] ||
          this.currentGroupCapabilities[GRUPO_VER_TODOS_OS_PLANTOES] ||
          this.currentGroupCapabilities[GRUPO_COMPARTILHAR_TODOS_OS_PLANTOES]
      }
      return false
    },

    permissaoNovaEscala () {
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[GRUPO_NOVA_ESCALA] === true
    },

    permissaoVerValores () {
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[GRUPO_VER_VALORES] === true
    },

    permissaoVerUsuarios () {
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[GRUPO_VER_USUARIOS] === true
    },

    permissaoConvidarUsuario () {
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[GRUPO_CONVIDAR_USUARIO] === true
    },

    permissaoGrupoAlterarDetalhesDaEscala () {
      // console.log('::: permissaoGrupoAlterarDetalhesDaEscala:', this.currentGroupCapabilities, GRUPO_ALTERAR_DETALHES_DA_ESCALA, !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[GRUPO_ALTERAR_DETALHES_DA_ESCALA] === true)
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[GRUPO_ALTERAR_DETALHES_DA_ESCALA] === true
    },

    permissaoGrupoEditarDetalhes () {
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[GRUPO_EDITAR_DETALHES] === true
    },

    permissaoGrupoCriarEscala () {
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[GRUPO_CRIAR_ESCALA] === true
    },

    permissaoVerUsuarios () {
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[GRUPO_VER_USUARIOS] === true
    },

    permissaoVerValores () {
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[GRUPO_VER_VALORES] === true
    },

    permissaoGrupoAcompanharEscala () {
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[GRUPO_ACOMPANHAR_ESCALA] === true
    },

    permissaoAcoesEscala () {
      return !!this.currentGroupCapabilities === true && (
        this.currentGroupCapabilities[ESCALA_APAGAR] ||
        this.currentGroupCapabilities[ESCALA_RENOVAR_LINK] ||
        this.currentGroupCapabilities[ESCALA_COMPARTILHAR]
      )
    },

    /* permissaoEscalaApagar () {
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[ESCALA_APAGAR] === true
    },

    permissaoEscalaRenovarLink () {
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[ESCALA_RENOVAR_LINK] === true
    },

    permissaoEscalaCompartilhar () {
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[ESCALA_COMPARTILHAR] === true
    }, */

    permissaoEscalaRetirarUsuario () {
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[ESCALA_RETIRAR_USUARIO] === true
    },

    permissaoEscalaAlterarPapel () {
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[ESCALA_ALTERAR_PAPEL] === true
    },

    permissaoEscalaVerPlantoesDoUsuario () {
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[ESCALA_VER_PLANTOES_DO_USUARIO] === true
    },

    //
    // Mapeia o papel do solicitante
    //
    // O código abaixo captura atualizações DEEP ?
    //

    VIEWER_GROUP_LEVEL () {
      if (!this.$route.params.groupID) return ""
      return ((this.groups ?? []).find(g => g.groupID === this.$route.params.groupID) ?? {})?.viewerLevel || ""
    },
  },

  watch: {
    groupUsersItemsPerPage: {
      immediate: true,
      handler(newValue) {
        this.itemsPerPage = newValue
      }
    },

    searchQuery: {
      handler(val) {
        this._debounceSearch(val)
      }
    },

    // Isso é bom para ver como o preparedUsers reage a mudanças em
    // tempo de execução (recarregamento da lista via reloadUsers) ou
    // em tempo real (listener de escalas do Firebase que ainda existe no gestor)

    /* preparedUsers: {
      immediate: true,
      handler(users) {
        console.log('::: Group/script.js ~ watch ~ preparedUsers:', users)
      }
    }, */

    groupUsers: {
      immediate: true,
      handler(users) {
        this.usersLoadingStatus = Object.fromEntries(users.map(u => [u.userID, false]))
        console.log('::: Group/script.js ~ watch ~ groupUsers ~ usersLoadingStatus:', this.usersLoadingStatus)
      }
    },
  },

  mounted ()
  {
    // Inicializações
    moment.locale('pt-BR')

    // Inicia carregamento dos dados da tela do grupo
    this.$store.dispatch('loadGroupPage', this.$route.params.groupID)

    // Inicia carregamento dos dados da aba correta pela rota
    this.initializeTabFromRoute()

    // Verificar se o usuário logado é master do grupo
    this.loggedUserIsMaster = this.checkLoggedUserIsMaster({
      groupID: this.$route.params.groupID,
      currentUserEmail: this.userSession.userEmail
    });

    // Listener para atualizações de papéis de usuários vindas do DialogUserPlanManager
    // this.$root.$once('userRolesUpdated', this.onUserRolesUpdated)

    // Inicia carregamento dos dados de "working hours"
    this.getWorkingHoursRulesByGroup(this.$route.params.groupID)
  },

  // beforeDestroy () {
  //   // Remove listener para evitar memory leaks
  //   this.$root.$off('userRolesUpdated', this.onUserRolesUpdated)
  // },

  created ()
  {
    // Cria uma função que atrasa um pouquinho a execução da busca
    // enquanto o usuário digita os termos de busca

    this._debounceSearch = (function () {
      let t
      return v => {
        clearTimeout(t)

        this.searchResultText = "Aguardando o fim da digitação para iniciar a busca..."

        t = setTimeout(() => {
          this.debouncedSearch = v

          if (v.length === 0 || v.length >= 3)
          {
            // Desativa balão de digitação para não ficar persistindo até a próxima digitação
            this.SHOW_SEARCH_HINT = false

            // Volta para a primeira página
            if (this.currentPage !== 1) this.currentPage = 1

            // Carrega a lista com termos de busca
            this.reloadUsers({ page: 1, search: v })
          }
        }, 700)
      }
    }).call(this)
  },

  methods: {
    //
    //
    //

    ...mapActions({
      getWorkingHoursRulesByGroup: types.GET_RULES_BY_GROUP_ID,
      deleteWorkingHoursRule: types.DELETE_RULE,
    }),

    // Verifica se o usuário atual é master do grupo
    async checkLoggedUserIsMaster({ groupID, currentUserEmail }) {
      if (!currentUserEmail) return

      try {
        const response = await apiCheckUserInGroup({
          groupID,
          userEmail: currentUserEmail
        })

        return response.data.role === MASTER_USER_ROLE
      } catch (error) {
        console.error('Erro ao verificar se usuário é master:', error)
        return false;
      }
    },

    dailyReportLoadingStatus (status)
    {
      this.loadingReport = status ? 'LOADING' : 'DONE'
    },

    //
    //
    //

    handleSearch(event)
    {
      const text = this.searchQuery.trim()

      // console.log("::: text:", event?.target?.value || "", `${text}`)

      this.SHOW_SEARCH_HINT = text.length > 0 /* && text.length < SEARCH_MIN_LENGTH */
    },

    // refreshUsersList () {
    //   this.$store.dispatch('loadGroupUsers', {
    //     groupID: this.$route.params.groupID,
    //     page: this.currentPage,
    //     search: this.searchQuery,
    //   });
    // },

    // Avança para a próxima página
    nextPage () {
      if (this.currentPage < this.totalPages) this.currentPage++

      this.reloadUsers({ page: this.currentPage, search: this.searchQuery })
    },

    // Retorna para a página anterior
    previousPage () {
      if (this.currentPage > 1) this.currentPage--

      this.reloadUsers({ page: this.currentPage, search: this.searchQuery })
    },

    setPage (currentPage)
    {
      this.currentPage = parseInt(currentPage)

      this.reloadUsers({ page: this.currentPage, search: this.searchQuery })
    },

    getUniqueTurns(turnos) {
      if (!turnos || !Array.isArray(turnos)) return []

      const seen = new Set()

      return turnos.filter(item => {
        const k = item.turnStart
        const duplicate = seen.has(k)
        seen.add(k)
        return !duplicate
      })
    },

    //
    //
    //

    userActions (u)
    {
      const viewerID = (this.$store.state ?? {})?.app?.userSession?.uid || ""

      if (!viewerID || !!u === false || !this.VIEWER_GROUP_LEVEL) {
        return []
      }

      const USER_MENU = []

      // -- Passar master
      // Só mostra "Passar Master" se o usuário atual for master do grupo
      // Não permite passar master para si mesmo
      // Não permite passar master para usuário gerenciado pelo Hugol (RM)
      if (this.VIEWER_GROUP_LEVEL === "MASTER" && u.userID !== viewerID && !this.isUserHugolManaged(u)) {
        USER_MENU.push({ id: 'TRANSFER_MASTER', icon: 'mdi-crown', title: 'Passar master', payload: u })
      }

      // --- Ver plantões do usuário

      if (this.permissaoEscalaVerPlantoesDoUsuario)
      {
        USER_MENU.push({ id: 'USER_DUTIES', icon: 'mdi-magnify', title: 'Ver plantões', payload: u })
      }

      // --- Retirar usuário do grupo
      if (
        this.permissaoEscalaRetirarUsuario &&
        (
          // Solicitante pode retirar qualquer pessoa diferente de si mesmo e que não esteja um nível acima
          !u.IS_VIEWER
          &&
          (
            u.role !== "MASTER"
            ||
            (u.role === "MASTER" && this.VIEWER_GROUP_LEVEL === "MASTER")
          )
        )
      ) {
        USER_MENU.push({ id: 'KICK_USER', icon: 'mdi-account-off', title: 'Retirar do grupo', payload: u })
      }

      // --- Configurar carga horária máxima de trabalho

      USER_MENU.push({ id: 'SET_WORKING_HOURS_USER', icon: 'mdi-clock-outline', title: 'Configurar carga horária máxima de trabalho', payload: u })

      return USER_MENU
    },

    //
    //
    //

    scaleActions (scaleItem) {
      const actions = []
      if (this.currentGroupCapabilities) {
        // if (this.currentGroupCapabilities[ESCALA_APAGAR] || this.currentGroupCapabilities[ESCALA_RENOVAR_LINK] || this.currentGroupCapabilities[ESCALA_COMPARTILHAR]) actions.push({ id: 'TITLE', title: 'Ações da escala' })
        if (this.currentGroupCapabilities[ESCALA_APAGAR]) actions.push({ id: 'DELETE_SCALE', icon: 'mdi-trash-can', title: 'Apagar escala', payload: scaleItem })
        if (this.currentGroupCapabilities[ESCALA_RENOVAR_LINK]) actions.push({ id: 'RENEW_SCALE_LINK', icon: 'mdi-refresh', title: 'Renovar link da escala', payload: scaleItem })
        if (this.currentGroupCapabilities[ESCALA_COMPARTILHAR]) actions.push({ id: 'SHARE_SCALE', icon: 'mdi-share-variant-outline', title: 'Compartilhar escala', payload: scaleItem })
        if (this.currentGroupCapabilities[ESCALA_COMPARTILHAR]) actions.push({ id: 'SHARE_SCALE_CUSTOM', icon: 'mdi-share-variant', title: 'Compartilhar escala (personalizado)', payload: scaleItem })
        actions.push({ id: 'SET_WORKING_HOURS_SCALE', icon: 'mdi-clock-outline', title: 'Configurar carga horária máxima de trabalho', payload: scaleItem })
      }
      return actions
    },

    onDragStart(item, event) {
      this.draggedItem = item;
      item.isDragging = true;
      event.dataTransfer.setData('text/plain', '');
    },

    onDragOver(item) {
      if (this.draggedItem === item) return;

      // Encontra os índices dos itens no array
      const fromIndex = this.groupScales.indexOf(this.draggedItem);
      const toIndex = this.groupScales.indexOf(item);

      // Remove o item arrastado da posição original
      this.groupScales.splice(fromIndex, 1);
      // Adiciona o item na nova posição
      this.groupScales.splice(toIndex, 0, this.draggedItem);
    },

    onDrop(item) {
      this.draggedItem.isDragging = false;
    },

    onDragEnd() {
      if (this.draggedItem) {
        this.draggedItem.isDragging = false;
        this.draggedItem = null;
      }

      const newScaleIds = this.groupScales.map(scale => scale.scaleID);


      apiUpdateScaleOrder(this.$route.params.groupID, newScaleIds, this.$store.state.app.userSession.userToken)
        .then(() => {
          return;
        })
        .catch(error => {
          this.showMessage('Erro', 'Não foi possível salvar a nova ordem. Por favor, tente novamente.');
        });
    },

    //
    //
    //

    initializeTabFromRoute()
    {
      const tabFromQuery = this.$route.query.tab

      const validTabs = ['escalas', 'solicitados', 'daily_report', 'working_hours', 'usuarios']

      if (!!tabFromQuery === true && validTabs.includes(tabFromQuery))
      {
        this.groupTab = tabFromQuery

        // se a tabela for de usuários, carrega os usuários
        if(tabFromQuery === 'usuarios')
        {
          this.reloadUsers({ page: this.currentPage, search: this.searchQuery })
        }
      }
    },

    /**
     *
     * DAILY REPORT - METHODS
     *
     */

    //

    /**
     *
     * OPEN "GROUP EDIT" MODAL
     *
     */

    openGroupEditModal ()
    {
      // console.log(`::: TENTANDO ABRIR OS DETALHES DO GRUPO "${this.$route.params.groupID}":`, this.group)

      if (!this.group) return

      this.$refs.mdGroupEditModal.open(this.group)
    },

    closeGroupEditModal (type) {
      // [24/01/25] console.log('::: closeGroupEditModal[type]:', type)
    },

    /**
     *
     * COPIAR LINK "COMPARTILHAR PLANTÕES DO GRUPO"
     *
     */

    onClickCopiarLinkPlantoes () {
      const text = `${process.env.VUE_APP_BASE_URL}plantoes/link/${this.$route.params.groupID}/${this.group.groupShareCode}`

      const $this = this

      navigator.clipboard.writeText(text).then(function () {
        // [24/01/25] console.log('onClickCopiarLink:', text)
        // alert('Link copiado com sucesso!')
        $this.shareShiftsVisible = false
      }, function () {
        alert('Não foi possível copiar o link')
      })
    },

    onClickWhatsAppPlantoes () {
      const scaleURL = `${process.env.VUE_APP_BASE_URL}plantoes/link/${this.$route.params.groupID}/${this.group.groupShareCode}`
      const text = `Olá! Clique no link para ver os plantões do grupo ${this.group.nome} no SOS Gestor.\n ${scaleURL}`
      const URL = `https://wa.me/?text=${text}`

      this.shareShiftsVisible = false

      window.open(URL, '_blank')
    },

    onClickTelegramPlantoes () {
      const scaleURL = `${process.env.VUE_APP_BASE_URL}plantoes/link/${this.$route.params.groupID}/${this.group.groupShareCode}`
      const text = encodeURIComponent(`Olá! Clique no link para ver os plantões do grupo ${this.group.nome} no SOS Gestor.`)
      const URL = `https://t.me/share/url?url=${scaleURL}&text=${text}`

      this.shareShiftsVisible = false

      window.open(URL, '_blank')
    },

    onClickFacebookPlantoes () {
      const scaleURL = `${process.env.VUE_APP_BASE_URL}plantoes/link/${this.$route.params.groupID}/${this.group.groupShareCode}`
      const URL = `https://facebook.com/sharer/sharer.php?u=${scaleURL}`

      this.shareShiftsVisible = false

      window.open(URL, '_blank')
    },

    onClickLinkedInPlantoes () {
      const scaleURL = `${process.env.VUE_APP_BASE_URL}plantoes/link/${this.$route.params.groupID}/${this.group.groupShareCode}`
      const URL = `https://www.linkedin.com/shareArticle?mini=true&url=${scaleURL}`

      this.shareShiftsVisible = false

      window.open(URL, '_blank')
    },

    /**
     *
     * ?
     *
     */

    onClickCopiarLink (scale) {
      const text = scale.custom
        ? `${process.env.VUE_APP_BASE_URL}${scale.type === 'scale' ? 'escala' : 'grupo'}/${scale.token}`
        : `${process.env.VUE_APP_BASE_URL}escala/link/${this.$route.params.groupID}/${scale.scaleID}/${scale.scaleCode}`;

      const $this = this

      navigator.clipboard.writeText(text).then(function () {
        // [24/01/25] console.log('onClickCopiarLink:', text)
        // alert('Link copiado com sucesso!')
        $this.sheet = false
        $this.sharedScaleItem = null
      }, function () {
        alert('Não foi possível copiar o link')
      })
    },

    onClickWhatsApp (scale) {
      const scaleURL = scale.custom
        ? `${process.env.VUE_APP_BASE_URL}${scale.type === 'scale' ? 'escala' : 'grupo'}/${scale.token}`
        : `${process.env.VUE_APP_BASE_URL}escala/link/${this.$route.params.groupID}/${scale.scaleID}/${scale.scaleCode}`;

      const text = `Olá! Clique no link para participar da escala ${scale.scaleName} no SOS Gestor.\n ${scaleURL}`
      const URL = `https://wa.me/?text=${text}`

      this.sheet = false
      this.sharedScaleItem = null

      window.open(URL, '_blank')
    },

    onClickTelegram (scale) {
      const scaleURL = scale.custom
        ? `${process.env.VUE_APP_BASE_URL}${scale.type === 'scale' ? 'escala' : 'grupo'}/${scale.token}`
        : `${process.env.VUE_APP_BASE_URL}escala/link/${this.$route.params.groupID}/${scale.scaleID}/${scale.scaleCode}`;

      const text = encodeURIComponent(`Olá! Clique no link para participar da escala ${scale.scaleName} no SOS Gestor.`)
      const URL = `https://t.me/share/url?url=${scaleURL}&text=${text}`

      this.sheet = false
      this.sharedScaleItem = null

      window.open(URL, '_blank')
    },

    onClickFacebook (scale) {
      const scaleURL = scale.custom
        ? `${process.env.VUE_APP_BASE_URL}${scale.type === 'scale' ? 'escala' : 'grupo'}/${scale.token}`
        : `${process.env.VUE_APP_BASE_URL}escala/link/${this.$route.params.groupID}/${scale.scaleID}/${scale.scaleCode}`;

      const URL = `https://facebook.com/sharer/sharer.php?u=${scaleURL}`

      this.sheet = false
      this.sharedScaleItem = null

      window.open(URL, '_blank')
    },

    onClickLinkedIn (scale) {
      const scaleURL = scale.custom
        ? `${process.env.VUE_APP_BASE_URL}${scale.type === 'scale' ? 'escala' : 'grupo'}/${scale.token}`
        : `${process.env.VUE_APP_BASE_URL}escala/link/${this.$route.params.groupID}/${scale.scaleID}/${scale.scaleCode}`;

      const URL = `https://www.linkedin.com/shareArticle?mini=true&url=${scaleURL}`

      this.sheet = false
      this.sharedScaleItem = null

      window.open(URL, '_blank')
    },

    /**
     *
     * ?
     *
     */

    shareScale (scale) {
      if (!!scale.scaleCode === false) return this.showMessage('Atenção!', '<b style="color: dodgerblue; font-size: 18px; line-height: 1">Atualização em 18/10/2024:</b><br /><br />Agora os gestores podem bloquear os links compartilhados.<br /><br /><b style="color: dodgerblue; font-size: 18px; line-height: 1">Instrução para compartilhar:</b><br /><br />Essa escala ainda não está protegida, então clique na ação <b>Renovar link da escala</b> e depois compartilhe o link para os usuários.')

      this.sheet = true
      this.sharedScaleItem = scale
    },

    //
    // CONFIGURAÇÃO DE COMPARTILHAMENTO PERSONALIZADO DA ESCALA

    sharePersonalizedScale (scale) {
      if (!!scale.scaleCode === false) return this.showMessage('Atenção!', '<b style="color: dodgerblue; font-size: 18px; line-height: 1">Atualização em 18/10/2024:</b><br /><br />Agora os gestores podem bloquear os links compartilhados.<br /><br /><b style="color: dodgerblue; font-size: 18px; line-height: 1">Instrução para compartilhar:</b><br /><br />Essa escala ainda não está protegida, então clique na ação <b>Renovar link da escala</b> e depois compartilhe o link para os usuários.')
      this.$refs.ShareScaleConfigModal.open(scale);
    },

    //Configuração de compartilhamento personalizado do grupo
    sharePersonalizedGroup(group) {
      this.$refs.ShareScaleConfigModal.open(group);
    },

    //
    //
    //

    setPayrollButtonState (state) {
      this.btnState.folhaDePagamento = state
    },

    //
    //
    //

    async handleUpdateShareLink({ linkId, config }) {
      try {
        const response = await this.$store.dispatch('shareScale/UPDATE_LINK', { linkId, config });
        const data = response.data;
        this.sharedScaleItem = {
          custom: true,
          type: data.type,
          token: data.token,
        }
        this.sheet = true;
      } catch (error) {
        console.error('Erro ao atualizar o link:', error);
        this.showMessage('Erro', error.message || 'Não foi possível atualizar o link.');
      }
    },

    async handleGenerateShareLink(config) {
      try {
        const response = await this.$store.dispatch('shareScale/CREATE_LINK', config);
        const data = response.data;
        //Em caso de sucesso, a ação retorna os dados da API (incluindo a nova URL).
        const token = data.token;

        this.sharedScaleItem = {
          custom: true,
          type: data.type,
          token: token,
        };
        this.sheet = true;
      } catch (error) {
        console.error('Erro ao gerar o link via Vuex:', error);

        this.showMessage('Erro', error.message || 'Não foi possível gerar o link de compartilhamento.');
      }
    },

    closeShareScaleConfigModal() {
      //TODO lógica de fechamento do modal
    },

    //
    // CALLBACK QUANDO O MASTER É TRANSFERIDO
    //

    onTransferMasterSuccess ({ title, message, oldMasterUserID, newMasterUserID }) {
      this.showMessage(title, message)
      this.onMasterTransferred({ oldMasterUserID, newMasterUserID })
    },

    async onMasterTransferred ({ oldMasterUserID, newMasterUserID }) {
      this.loggedUserIsMaster = false
      await this.reloadUsers({ page: this.currentPage, search: this.searchQuery })
    },

    //
    // CALLBACK QUANDO OS PAPÉIS DE USUÁRIOS SÃO ATUALIZADOS NO DIALOGUSERPLANMANAGER
    // reatividade na aba de usuários

    // onUserRolesUpdated (roleChanges) {
    //   // Só atualiza se a aba de usuários estiver aberta
    //   if (this.groupTab !== 'usuarios') return

    //   roleChanges.forEach(({ groupID, userID, newRole }) => {

    //     if (this.$route.params.groupID === groupID) {
    //       // this.$set(this.isMaster, userID, newRole === MASTER_USER_ROLE)
    //       // this.$set(this.isAdmin, userID, newRole === MASTER_USER_ROLE || newRole === MANAGER_USER_ROLE)

    //       this.isMaster[userID] = newRole === MASTER_USER_ROLE
    //       this.isAdmin[userID] = newRole === MASTER_USER_ROLE || newRole === MANAGER_USER_ROLE
    //     }
    //   })
    // },

    //

    onGroupActionClick (action)
    {
      //
      // USUÁRIOS
      //

      // INVITE USER
      if (action.id === 'INVITE_USER') this.$router.push(`/admin/grupos/${this.$route.params.groupID}/convidar`)

      // console.log(`::: ENTRANDO NA PÁGINA DE CONVITE ATRAVÉS DA PÁGINA DO GRUPO "${this.$route.params.groupID}"`)

      //
      // ESCALAS
      //

      // NEW SCALE
      if (action.id === 'NEW_SCALE') this.openScaleCreateModal(this.group)

      //
      // RELATÓRIOS
      //

      if (action.id === 'EXPORT_TIMESHEET') this.$refs.exportTimesheetModal.open() // OPEN "TIMESHEET EXPORT" MODAL
      if (action.id === 'EXPORT_TIMESHEET_SIMULATION') this.$refs.exportTimesheetSimulationModal.open() // OPEN "TIMESHEET SIMULATION EXPORT" MODAL
      if (action.id === 'EXPORT_PAYROLL') this.$refs.exportPayrollModal.open('NO', 'NO') // OPEN "PAYROLL EXPORT" MODAL
      if (action.id === 'EXPORT_OPERATIONAL_REPORT') {
        this.$refs.exportOperationalReportModal.open('NO', 'NO')
      }
       if (action.id === 'SET_WORKING_HOURS_GROUP') {
        this.workingHoursModal = {
          active: true,
          level: 'group',
          entityId: this.$route.params.groupID || null,
          groupId: this.$route.params.groupID,
        }
      }


      //
      // PLANTÕES
      //

      // RENOVAR LINK DO GRUPO
      if (action.id === 'GROUP_LINK_RENEWAL_CODE')
      {
        this.showDialog('Atenção!', 'O link atual do grupo' + (!!this.group.groupName === true ? ` "<i><b style="color: green; word-break: break-all">${this.group.groupName}</b></i>" ` : ' ') + 'vai expirar.<br><br><b style="color: indianred">ENVIE O NOVO LINK PARA A SUA EQUIPE APÓS CONFIRMAR A OPERAÇÃO!</b><br><br><b>Deseja continuar?</b>', 'groupLinkRenewal', '')
      }

      // SHARE GROUP SHIFTS
      if (action.id === 'GROUP_SHIFTS_SHARE')
      {
        if (!!this.group.groupShareCode === false) {
          return this.showMessage('Atenção!', '<b style="color: dodgerblue; font-size: 18px; line-height: 1">Atualização em 01/11/2024:</b><br /><br />Agora os gestores podem bloquear os links compartilhados.<br /><br /><b style="color: dodgerblue; font-size: 18px; line-height: 1">Instrução para compartilhar:</b><br /><br />O link do grupo ainda não está protegido, então clique na ação <b>Renovar link do grupo</b> e depois compartilhe o link para os usuários.')
        }

        this.shareShiftsVisible = true
      }

      // SHARE GROUP SHIFTS CUSTOM
      if (action.id === 'GROUP_SHIFTS_SHARE_CUSTOM'){
        this.sharePersonalizedGroup(this.group);
      }

      // VIEW ALL GROUP SHIFTS
      if (action.id === 'GROUP_SHIFTS_SHOW') this.$router.push(`/admin/grupos/${this.$route.params.groupID}/plantoes`)

      // CREATE SERIES
      if (action.id === 'CREATE_SERIES') this.$router.push(`/admin/series/${this.$route.params.groupID}/form`)
    },

    //
    //
    //

    onUserActionClick (action)
    {
      // TRANSFER MASTER
      if (action.id === 'TRANSFER_MASTER') {
        this.transferMasterModal = {
          active: true,
          groupID: this.$route.params.groupID,
          currentMasterUserID: this.userSession.uid || '',
          preSelectedUser: action.payload || {},
        }
      }

      // USER_DUTIES
      // sos-button(@buttonClick="openUserTurns(userItem.userID)" color="purple" buttonLabel="Ver plantões" buttonIcon="mdi-magnify" buttonIconSize="16" :disabled="allLoadingUsers[userItem.userID]").mr-1

      if (action.id === 'SET_WORKING_HOURS_USER')
      {
        this.workingHoursModal = {
          active: true,
          level: 'user',
          entityId: action.payload.userID || null,
          groupId: this.$route.params.groupID,
          // scaleId: action.payload.scaleID || null,
          scaleId: null,
        }
      }

      if (action.id === 'USER_DUTIES') this.openUserTurns(action.payload.userID)

      if (action.id === 'KICK_USER') this.kickUserConfirm(action.payload)
    },

    onScaleActionClick (action)
    {
      if (action.id === 'DELETE_SCALE') this.confirmScaleDelete(action.payload)

      if (action.id === 'RENEW_SCALE_LINK') this.confirmScaleLinkRenew(action.payload)

      if (action.id === 'SHARE_SCALE') this.shareScale(action.payload)

      if (action.id === 'SHARE_SCALE_CUSTOM') this.sharePersonalizedScale(action.payload)

      if (action.id === 'SET_WORKING_HOURS_SCALE') {
        this.workingHoursModal = {
          active: true,
          level: 'scale',
          entityId: action.payload.scaleID || null,
          groupId: this.$route.params.groupID,
        }
      }
    },

    goToScale (scaleID) {
      this.$router.push(`/admin/grupos/${this.$route.params.groupID}/escalas/${scaleID}`)
    },

    goToEditScale (scaleID) {
      this.$router.push(`/admin/grupos/${this.$route.params.groupID}/escalas/${scaleID}/editar`)
    },

    /**
     *
     * ?
     *
     */

    openUserTurns (userID) {
      if (this.actionLoading === true) {
        // console.log('::: O sistema está ocupado e não pode abrir os plantões do usuário agora...')
        return false
      }

      // console.log(`::: ENTRANDO NA PÁGINA DE PLANTÕES DO USUÁRIO ATRAVÉS DA PÁGINA DO GRUPO "${this.$route.params.groupID}"`)
      this.$router.push(`/admin/grupos/${this.$route.params.groupID}/usuario/${userID}/plantoes`)
    },

    //
    //
    //

    async reloadUsers({ page, search })
    {
      const requestId = ++this.currentSearchRequestId

      this.searchResultText = this.isModeSearch ? "Buscando..." : (
        this.preparedUsers.length > 0 /* this.preparedUsers.length === 0 && this.isGroupUsersLoading */ ? "Listando..." : ""
      )

      const args = { groupID: this.$route.params.groupID, page }
      if (search) args.search = search

      const request = await this.$store.dispatch('loadGroupUsers', args)

      // 🚨 Se essa não for a última requisição, IGNORA
      if (requestId !== this.currentSearchRequestId) {
        return
      }

      // if (request.status === "LOADING") return

      if (request.data.httpCode !== 200)
      {
        this.searchResultText = "Parece que a listagem falhou. Tente novamente!"

        this.showMessage(request.title, request.message)
      }
      else
      {
        this.searchResultText = this.searchQuery ? (
          this.totalUsers === 1 ? '1 ocorrência' : (
            this.totalUsers === 0 ? `Nenhuma ocorrência para "${this.searchQuery}"` : (
              `${this.totalUsers} ocorrências para "${this.searchQuery}"`
            )
          )
        ) : ""
      }
    },

    //
    //
    //
    //
    //
    //
    // --- Nível do usuário
    //
    //
    //
    //
    //
    //

    // Verifica se o usuário é gerenciado pelo Hugol (RM) através do employeeId e origin
    isUserHugolManaged (userItem)
    {
      return !!userItem?.hugol?.employeeId || userItem?.hugol?.origin === "HUGOL"
    },

    async setUserRole (userItem)
    {
      // console.log("::: setUserRole:", userItem)

      //  usuário é gerenciado pelo Hugol (RM)?

      if (this.isUserHugolManaged(userItem)) {
        return this.showMessage(
          "Atenção!",
          `O papel de <b style="color: indianred">${userItem.userName}</b> é definido pelo RM. Para alterar, solicite a mudança no sistema de RH (RM).`
        )
      }

      // --- Não pode executar enquanto outro carregamento estiver em andamento

      if (this.usersLoadingStatus[userItem.userID] === true || this.actionLoading === true) {
        return this.showMessage("Atenção!", `O sistema está ocupado e você não pode mudar o papel de <b style="color: indianred">${userItem.userName}</b> agora...`)
      }

      // --- Checa se o solicitante tem as permissões necessárias para operar esse usuário

      // Não permite o solicitante mudar o próprio papel
      if (userItem.IS_VIEWER) {
        return this.showMessage("Atenção!", "Você não pode alterar seu próprio nível")
      }

      // Carrega perfil do solicitante
      const VIEWER_PROFILE = await getUserByID(getUserUID())
      if (!VIEWER_PROFILE) {
        return this.showMessage("Atenção!", `Não foi possível alterar as permissões de <b style="color: indianred">${userItem.userName}</b>, pois não foi possível verificar as suas permissões nesse grupo!`)
      }

      //
      // Mapeia o papel do solicitante
      //
      // Preferível usar VIEWER_ROLE ao invés de this.VIEWER_GROUP_ROLE, pois o VIEWER_ROLE mostra o nível exatamente agora
      // enquanto o this.VIEWER_GROUP_ROLE espera a lista de grupos atualização após mudar o nível do usuário logado ser alterado no grupo.
      //
      // Reconsiderar isso quando o endpoint de LISTA DE GRUPOS ou LER GRUPO estiver ativado no painel gestor
      //

      const VIEWER_GROUP_SETTINGS = (VIEWER_PROFILE ?? {})?.grupos?.[this.$route.params.groupID] || null

      // Cenário possível quando abre o grupo via LINK SECRETO (supadgroups)
      if (!VIEWER_GROUP_SETTINGS) {
        return this.showMessage("Atenção!", "Você não faz parte do grupo e não pode gerenciar usuários deste grupo.")
      }

      const VIEWER_ROLE = (VIEWER_GROUP_SETTINGS?.master || false) ? "MASTER" : (
        (VIEWER_GROUP_SETTINGS?.admin || false) ? "ADMIN" : "MEMBER"
      )

      // Cenário teóricamente impossível, mas garante que o solicitante sempre tenha poderes administrativos
      if (VIEWER_ROLE === "MEMBER") {
        return this.showMessage("Atenção!", "Você não tem permissão suficiente para gerenciar usuários deste grupo.")
      }

      // Apenas um MASTER pode REBAIXAR outro MASTER
      if (VIEWER_ROLE !== "MASTER" && userItem.role === "MASTER") {
        return this.showMessage("Atenção!", `Você não tem permissão suficiente para alterar o papel de <b style="color: indianred">${userItem.userName}</b>.`)
      }

      // --- Definimos o novo papel com base nas permissões dos dois atores envolvidos

      let NEW_LEVEL = ""
      if (VIEWER_ROLE === "MASTER") {
        // 1) Usuário é MASTER ou ADMIN → Usuário se tornará MEMBRO
        if (userItem.role === "MASTER" || userItem.role === "ADMIN") NEW_LEVEL = "MEMBER"
        // 3) Se o usuário é ADMIN e o soliciante é MASTER → Usuário se tornará MASTER
      } else {
        // 2) Usuário e solicitante são ADMIN → Usuário se tornará MEMBRO, pois ADMIN não pode promover outro ADMIN a MASTER
        if (userItem.role === "ADMIN") NEW_LEVEL = "MEMBER"
      }
      // 4) Usuário comum → pode se tornar admin se quem gerencia for admin ou master
      if (userItem.role === "MEMBER") NEW_LEVEL = "ADMIN"

      // --- Executa o endpoint

      this.actionLoading = true
      this.$set(this.usersLoadingStatus, userItem.userID, true)

      const response = await apiSetGroupUserLevel(this.$route.params.groupID, userItem.userID, NEW_LEVEL)

      this.$set(this.usersLoadingStatus, userItem.userID, false)
      this.actionLoading = false

      // --- Recarrega a lista em caso de sucesso

      if (response.httpCode === 200) {
        this.reloadUsers({ page: this.currentPage, search: this.searchQuery })
      }

      // --- Mostra a resposta do back-end independente do resultado

      this.showMessage(response.title, response.message)
    },

    /*
    // [staging-portaltelemedicina / master-portaltelemedicina]
    //
    //
    //
    //
    //
    //
    // --- Elevar ou rebaixar o usuário da posição de município
    //
    //
    //
    //
    //
    //

    async setUserAsMunicipality (userItem)
    {
      // console.log("::: setUserAsMunicipality:", userItem)

      // --- Não pode executar enquanto outro carregamento estiver em andamento

      if (this.usersLoadingStatus[userItem.userID] === true || this.actionLoading === true) {
        return this.showMessage("Atenção!", `O sistema está ocupado e você não pode atribuir ou revogar o papel de município de <b style="color: indianred">${userItem.userName}</b> agora...`)
      }

      // --- Checa se o solicitante tem as permissões necessárias para operar esse usuário

      if (userItem.role === "MEMBER") {
        return this.showMessage("Atenção!", "Apenas gestores podem ser marcados como município")
      }

      // --- Executa o endpoint

      const currentMunicipalityStatus = userItem.isMunicipality
      const newMunicipalityStatus = !currentMunicipalityStatus

      this.actionLoading = true
      this.$set(this.usersLoadingStatus, userItem.userID, true)

      const response = await apiUpdateGroupUserMunicipalityRole(this.$route.params.groupID, userItem.userID, newMunicipalityStatus)

      this.$set(this.usersLoadingStatus, userItem.userID, false)
      this.actionLoading = false

      // --- Recarrega a lista em caso de sucesso

      if (response.httpCode === 200) {
        this.reloadUsers({ page: this.currentPage, search: this.searchQuery })
      }

      // --- Mostra a resposta do back-end independente do resultado

      this.showMessage(response.title, response.message)
    },
    // [staging-portaltelemedicina / master-portaltelemedicina]
    */

    /**
     *
     * ?
     *
     */


    setTab (tab = 'escalas')
    {
      if (tab === 'usuarios' && !this.permissaoVerUsuarios) {
        this.groupTab = 'escalas'
        return false
      }

      this.groupTab = tab

      // Carrega os usuários quando a aba de usuários for ativada

      if (tab === 'usuarios' && this.groupUsers.length === 0 && !this.isGroupUsersLoading)
      {
        this.reloadUsers({ page: 1 })
      }
    },

    goToGroups () {
      this.$router.push('/admin/grupos/')
    },

    /**
     *
     * HANDLE SCALE CREATE MODAL
     *
     */

    openScaleCreateModal (group) {
      // console.log('::: openScaleCreateModal:', group)

      const groupScalesAmount = !!this.groupScales === true && Array.isArray(this.groupScales) ? this.groupScales.length : 0

      const limiteEscalas = Number(this.userSession.userCapabilities.limiteEscalas)

      if (freeVersion === false && groupScalesAmount >= limiteEscalas)
      {
        const planName = this.userSession.planName.name

        const textSupport = `<p>Por favor, converse com o nosso <a href="https://api.whatsapp.com/send?phone=5513992061010&text=Olá, estou no ${planName} e não consigo criar escalas. Preciso de ajuda." target="_blank">suporte</a> e saiba como aumentar o limite de escalas.</p>`

        if (this.userSession.planOrigin === 'CUSTOM') {
          // Plano personalizado
          this.openSubscriptionModal('Verifique seu plano', `<p>Você está no ${planName} personalizado, mas atingiu o limite de ${limiteEscalas} ${limiteEscalas === 1 ? ' escala concedida' : ' escalas concedidas'}.</p>${textSupport}`)
        } else if (this.userSession.planOrigin === 'COUPON') {
          // Cupom ativo
          this.openSubscriptionModal('Verifique seu plano', `<p>Você tem um cupom ativo, mas atingiu o limite de ${limiteEscalas} ${limiteEscalas === 1 ? ' escala concedida' : ' escalas concedidas'}.</p>${textSupport}`)
        } else if (this.userSession.planOrigin === 'VINDI' && this.userSession.vindi.paymentStatus === 'paid') {
          // Assinatura ativa na vindi
          this.openSubscriptionModal('Faça um upgrade', `<p>Você atingiu o limite de ${limiteEscalas} ${limiteEscalas === 1 ? ' escala concedida' : ' escalas concedidas'} no ${planName}.</p>${textSupport}`)
        } else if (this.userSession.planOrigin === 'VINDI' && this.userSession.vindi.paymentStatus !== 'paid') {
          // Assinatura ativa, mas com alguma pendência ou erro na vindi
          this.openSubscriptionModal('Verifique sua assinatura', `<p>Você é assinante do ${planName}, mas ele não está ativo e você atingiu o limite de ${limiteEscalas} ${limiteEscalas === 1 ? ' escala concedida' : ' escalas concedidas'}.</p>${textSupport}`)
        } else {
          if (!!this.userSession.vindi === true) {
            // Plano da vindi expirado
            this.openSubscriptionModal('Verifique sua assinatura', `<p>Você assinou o ${this.userSession.vindi.planName.name}, mas ele expirou.</p><p>Agora você está no ${planName} e atingiu o limite de ${limiteEscalas} ${limiteEscalas === 1 ? ' escala concedida' : ' escalas concedidas'}.</p>${textSupport}`)
          } else {
            // Plano gratuíto ou alcançou alguma condição desconhecida
            this.openSubscriptionModal('Verifique seu plano', `<p>Você está no ${planName} e atingiu o limite de ${limiteEscalas} ${limiteEscalas === 1 ? ' escala concedida' : ' escalas concedidas'}.</p>${textSupport}`)
          }
        }

        return false
      }

      this.$refs.mdScaleCreate.open(group)
    },

    closeScaleCreateModal (action) {
      // [24/01/25] console.log('::: closeScaleCreateModal[action]:', action)
    },

    closeSubscriptionModal () {
      console.log('::: closeSubscriptionModal')
    },

    /**
     *
     * HANDLE SCALE EDIT DIALOG (ALTERAR DETALHES DA ESCALA)
     *
     */

    openScaleEditModal (selectedScale) {
      // [24/01/25] console.log('::: openScaleEditModal:', selectedScale)
      this.$refs.mdScaleEdit.open(selectedScale, this.group)
    },

    closeScaleEditModal (action) {
      // [24/01/25] console.log('::: closeScaleEditModal[action]:', action)
    },

    /**
     *
     * APAGAR ESCALA
     *
     */

    confirmScaleDelete (selectedScale) {
      this.showDialog('Atenção!', 'A escala "<i><b style="color: green; word-break: break-all">' + selectedScale.scaleName + '</b></i>" e todos os dados relacionados serão apagados.<br><br><b style="color: indianred">ESSA AÇÃO É IRREVERSÍVEL!</b><br><br><b>Deseja continuar?</b>', 'scaleDelete', selectedScale)
    },

    /**
     *
     * RENOVAR LINK DA ESCALA
     *
     */

    confirmScaleLinkRenew (selectedScale) {
      this.showDialog('Atenção!', 'O link atual da escala "<i><b style="color: green; word-break: break-all">' + selectedScale.scaleName + '</b></i>" vai expirar.<br><br><b style="color: indianred">ENVIE O NOVO LINK PARA A SUA EQUIPE APÓS CONFIRMAR A OPERAÇÃO!</b><br><br><b>Deseja continuar?</b>', 'scaleLinkRenewal', selectedScale)
    },

    /**
     *
     * ACEITAR PLANTÃO SOLICITADO VIA APLICATIVO
     *
     */

    confirmDutyAccept (duty) {
      if (this.actionLoading === true) {
        // console.log('::: O sistema está ocupado e não é possível aceitar o plantão no momento...')
        return false
      }

      // console.log('confirmDutyAccept:', duty)

      this.showDialog('Atenção!', 'Este plantão será incluído na escala e nos relatórios do usuário.<br><b>Deseja continuar?</b>', 'dutyAccept', duty)
    },

    /**
     *
     * RECUSAR PLANTÃO SOLICITADO VIA APLICATIVO
     *
     */

    confirmDutyRefuse (duty) {
      if (this.actionLoading === true) {
        // console.log('::: O sistema está ocupado e não é possível recusar o plantão no momento...')
        return false
      }

      // console.log('confirmDutyRefuse:', duty)

      this.showDialog('Atenção!', 'Este plantão será recusado.<br><b>Deseja continuar?</b>', 'dutyRefuse', duty)
    },

    /**
     *
     * RETIRAR USUÁRIO DO GRUPO
     *
     */

    kickUserConfirm (userItem)
    {
      // --- Solicitante não pode se retirar do grupo

      if (userItem.IS_VIEWER) {
        return this.showMessage("Atenção!", "Você não pode se retirar do grupo")
      }

      // --- Não pode executar enquanto outro carregamento estiver em andamento

      if (this.usersLoadingStatus[userItem.userID] === true || this.actionLoading === true) {
        return this.showMessage("Atenção!", `Outra operação está em andamento e você não pode retirar <b style="color: indianred">${userItem.userName}</b> do grupo...`)
      }

      // --- Pede confirmação para retirar o usuário do grupo

      this.showDialog('Atenção!', `${userItem.userName} será retirado(a) do grupo. <b>Deseja continuar?</b>`, 'kickUser', userItem)
    },

    /**
     *
     * GERENCIAR AÇÕES DO CONFIRM-DIALOG
     *
     */

    async cdAction (cdResponse)
    {
      // [24/01/25] console.log('cdAction:', cdResponse)

      if (cdResponse === false) return

      const type = cdResponse.cdType
      const data = cdResponse.cdData

      /**
       *
       * APAGAR ESCALA
       *
       */

      if (type === 'scaleDelete')
      {
        if (this.actionLoading === true) {
          // [24/01/25] console.log('::: o sistema está ocupado! não é possível apagar a escala no momento...')
          return
        }

        this.actionLoading = true
        const response = await apiDeleteScale(this.$route.params.groupID, data.scaleID)
        this.actionLoading = false

        this.showMessage(response.title, response.message)
      }

      /**
       *
       * RENOVAR LINK DA ESCALA
       *
       */

      if (type === 'scaleLinkRenewal') {
        if (this.actionLoading === true) {
          // console.log('::: o sistema está ocupado! não é possível renovar o link da escala no momento...')
          return false
        }

        // console.log(`::: RENOVANDO O LINK DA ESCALA "${data.scaleID}" DO GRUPO "${this.$route.params.groupID}"...`)

        this.actionLoading = true
        const request = await apiRenewScaleLink(this.$route.params.groupID, data.scaleID)
        this.actionLoading = false

        // console.log('::: scaleLinkRenewal -> result:', request)

        this.showMessage(request.title, request.response)
      }

      /**
       *
       * RENOVAR LINK DO GRUPO
       *
       */

      if (type === 'groupLinkRenewal') {
        if (this.actionLoading === true) {
          // console.log('::: o sistema está ocupado! não é possível renovar o link do grupo no momento...')
          return false
        }

        // console.log(`::: RENOVANDO O LINK DO GRUPO "${this.$route.params.groupID}"...`)

        this.actionLoading = true
        const request = await apiRenewGroupLink(this.$route.params.groupID)
        this.actionLoading = false

        // console.log('::: groupLinkRenewal -> result:', request)

        this.showMessage(request.title, request.response)
      }

      /**
       *
       * RECUSAR PLANTÃO DISPONÍVEL
       *
       */

      if (type === 'dutyRefuse') {
        if (this.actionLoading === true) {
          // [24/01/25] console.log('::: o sistema está ocupado! não é possível recusar o plantão no momento...')
          return false
        }

        //

        // [24/01/25] console.log('dutyRefuse:', data.dutyScaleValue, typeof data, data)

        //

        // [24/01/25] console.log(`::: RECUSANDO O PLANTÃO SOLICITADO VIA APLICATIVO "${data.waitingDutyID}"...`)

        /*
        // [staging-portaltelemedicina / master-portaltelemedicina]
        data.duracaoConsulta = false
        // [staging-portaltelemedicina / master-portaltelemedicina]
        */

        // this.actionLoading = true

        apiSetWaitingDutyStatus(data.waitingDutyID, 2, data, response => {
          // this.actionLoading = false

          if (response.code === 0) {
            // [24/01/25] console.log(`::: NÃO FOI POSSÍVEL RECUSAR O PLANTÃO DISPONÍVEL ${data.waitingDutyID}`, response)
          } else {
            // [24/01/25] console.log(`::: O PLANTÃO DISPONÍVEL ${data.waitingDutyID} FOI RECUSADO`, response)
          }
        })
      }

      /**
       *
       * ACEITAR PLANTÃO DISPONÍVEL
       *
       */

      if (type === 'dutyAcceptConfirm')
      {
        if (this.actionLoading === true) {
          // [24/01/25] console.log('::: o sistema está ocupado! não é possível aceitar o plantão no momento...')
          return false
        }

        //
        //
        //

        /*
        // [staging-portaltelemedicina / master-portaltelemedicina]
        data.duracaoConsulta = await apiGetScaleConsultationDuration(data.dutyGroupID, data.dutyScaleID)

        if (data.duracaoConsulta !== 6 && data.duracaoConsulta !== 10 && data.duracaoConsulta !== 15 && data.duracaoConsulta !== 20 && data.duracaoConsulta !== 30 && data.duracaoConsulta !== 60) {
          return this.showMessage('Atenção!', 'Defina um tempo de consulta na escala associada ao plantão solicitado')
        }
        // [staging-portaltelemedicina / master-portaltelemedicina]
        */

        //
        //
        //

        const time = data.dutyTime.split(':')
        const hour = time[0]
        const minute = time[1]

        const horaBase = minute === '00' ? parseInt(hour) : data.dutyTime
        const durationBase = data.dutyDuration.length === 2 ? parseInt(data.dutyDuration) : data.dutyDuration

        //

        data.horaBase = horaBase
        data.durationBase = durationBase

        const dutyStartDateBase = moment(data.dutyDate, 'YYYY-MM-DD')
        data.dataInicioFmt = dutyStartDateBase.format('YYYY-M-D')
        data.dutyDateMsg = dutyStartDateBase.format('DD/MM/YYYY')

        //

        // [24/01/25] console.log(`::: ACEITANDO O PLANTÃO SOLICITADO VIA APLICATIVO "${data.waitingDutyID}"...`, data.dutyScaleValue, data)

        // this.actionLoading = true

        apiSetWaitingDutyStatus(data.waitingDutyID, 1, data, response => {
          // this.actionLoading = false

          if (response.code === 0) {
            // [24/01/25] console.log(`::: NÃO FOI POSSÍVEL ACEITAR O PLANTÃO DISPONÍVEL ${data.waitingDutyID}`, response)
          } else {
            // [24/01/25] console.log(`::: O PLANTÃO DISPONÍVEL ${data.waitingDutyID} FOI ACEITO`, response)
          }
        })
      }

      if (type === 'dutyAccept')
      {
        if (this.actionLoading === true) {
          // [24/01/25] console.log('::: o sistema está ocupado! não é possível aceitar o plantão no momento...')
          return false
        }

        //
        //
        //

        /*
        // [staging-portaltelemedicina / master-portaltelemedicina]
        data.duracaoConsulta = await apiGetScaleConsultationDuration(data.dutyGroupID, data.dutyScaleID)

        if (data.duracaoConsulta !== 6 && data.duracaoConsulta !== 10 && data.duracaoConsulta !== 15 && data.duracaoConsulta !== 20 && data.duracaoConsulta !== 30 && data.duracaoConsulta !== 60) {
          return this.showMessage('Atenção!', 'Defina um tempo de consulta na escala associada ao plantão solicitado')
        }
        // [staging-portaltelemedicina / master-portaltelemedicina]
        */

        //
        //
        //
        // ------------------------------------------------------------------------------------------------
        // CONFLITOS (BEGIN)
        // ------------------------------------------------------------------------------------------------
        //
        //
        //

        const dataInicioPlantao = data.dutyDate.split('-')
        const dutyStartTime = valueToTime(data.dutyTime)

        //

        const selectedYear = Number(dataInicioPlantao[0])
        const selectedMonth = Number(dataInicioPlantao[1]) - 1

        const firstDate = moment.utc([selectedYear, selectedMonth, 1, 0, 0, 0, 0]).startOf('day')
        const lastDate = moment.utc([selectedYear, selectedMonth, 1, 0, 0, 0, 0]).endOf('month')

        // [24/01/25] console.log('::: selectedYear, selectedMonth:', selectedYear, selectedMonth)
        // [24/01/25] console.log('::: firstDate:', firstDate.format('YYYY-MM-DD HH:mm:ss'))
        // [24/01/25] console.log('::: lastDate:', lastDate.format('YYYY-MM-DD HH:mm:ss'))

        //
        //
        //
        // Mostra conflitos caso algum usuário tenha outro plantão no mesmo horário
        //
        //
        //

        // data.dutyGroupID
        const { conflictedScales = [], conflictsTableHtml = '' } = await canAddUserShift(dutyStartTime, [`${dataInicioPlantao[2]}/${dataInicioPlantao[1]}/${dataInicioPlantao[0]}`], /* this.listeners.groupScales, */ data.dutyCreatorID, firstDate, lastDate)

        if (conflictedScales.length > 0)
        {
          // this.loading = false

          const ownerName = data.dutyCreatorName.trim()
          const plantonistaText = ownerName.length > 0 ? `<b style="color: #778899">${ownerName}</b>` : 'O usuário'

          const text = `<div style="text-align: center">${plantonistaText} já tem um plantão nesse mesmo dia e horário.<br /><br />Veja os conflitos abaixo:<br /><br />${conflictsTableHtml}<br /><b>Deseja aceitar o plantão mesmo assim?</b></div>`
          this.showConfirmBox({
            title: 'Conflito!',
            text,
            type: 'dutyAcceptConfirm',
            data,
            isResponse: false,
            buttonPosition: 'right',
            width: 330,
            closeText: 'Não',
            continueText: 'Sim',
          })

          // Veja as escalas abaixo e resolva os conflitos para continuar

          // const text = `<div style="text-align: center">${plantonistaText} já tem um plantão nesse mesmo dia e horário.<br /><br />Resolva os conflitos abaixo:<br /><br />${conflictsTableHtml}</div>`
          // this.showMessage('Conflito!', text)

          // showDialog: function (title, text, type, data, isResponse = false, buttonPosition = 'right', width = 330) {

          // this.showDialog('Conflito!', text, 'dutyAcceptConfirm', data)

          return false
        }

        //
        //
        //
        // ------------------------------------------------------------------------------------------------
        // CONFLITOS (END)
        // ------------------------------------------------------------------------------------------------
        //
        //
        //

        const time = data.dutyTime.split(':')
        const hour = time[0]
        const minute = time[1]

        const horaBase = minute === '00' ? parseInt(hour) : data.dutyTime
        const durationBase = data.dutyDuration.length === 2 ? parseInt(data.dutyDuration) : data.dutyDuration

        //

        data.horaBase = horaBase
        data.durationBase = durationBase

        const dutyStartDateBase = moment(data.dutyDate, 'YYYY-MM-DD')
        data.dataInicioFmt = dutyStartDateBase.format('YYYY-M-D')
        data.dutyDateMsg = dutyStartDateBase.format('DD/MM/YYYY')

        //

        // [24/01/25] console.log(`::: ACEITANDO O PLANTÃO SOLICITADO VIA APLICATIVO "${data.waitingDutyID}"...`, data.dutyScaleValue, data)

        // this.actionLoading = true

        apiSetWaitingDutyStatus(data.waitingDutyID, 1, data, response => {
          // this.actionLoading = false

          if (response.code === 0) {
            // [24/01/25] console.log(`::: NÃO FOI POSSÍVEL ACEITAR O PLANTÃO DISPONÍVEL ${data.waitingDutyID}`, response)
          } else {
            // [24/01/25] console.log(`::: O PLANTÃO DISPONÍVEL ${data.waitingDutyID} FOI ACEITO`, response)
          }
        })
      }

      /**
       *
       * RETIRAR USUÁRIO DO GRUPO
       *
       */

      if (type === 'kickUser')
      {
        console.log("kickUser:", data)

        // --- Solicitante não pode se retirar do grupo

        if (data.IS_VIEWER) {
          return this.showMessage("Atenção!", "Você não pode se retirar do grupo")
        }

        // --- Não pode executar enquanto outro carregamento estiver em andamento

        if (this.usersLoadingStatus[data.userID] === true || this.actionLoading === true) {
          return this.showMessage("Atenção!", `Outra operação está em andamento e você não pode retirar <b style="color: indianred">${data.userName}</b> do grupo...`)
        }

        // --- Executa o endpoint

        this.actionLoading = true
        this.$set(this.usersLoadingStatus, data.userID, true)

        const response = await apiRemoveUserFromGroup(this.$route.params.groupID, data.userID)

        this.$set(this.usersLoadingStatus, data.userID, false)
        this.actionLoading = false

        // --- Recarrega a lista em caso de sucesso

        if (response.httpCode === 200)
        {
          this.reloadUsers({ page: this.currentPage, search: this.searchQuery })
        }

        // --- Mostra a resposta do back-end independente do resultado

        this.showMessage(response.title, response.message)
      }
    },

    //
    //
    //
    //
    //
    //
    // --- Gerencia escalas de um usuário
    //
    //
    //
    //
    //
    //

    async onSelectScale (optionValue, optionText, optionPayload)
    {
      console.log('::: onSelectScale:', { optionValue, optionText, optionPayload })

      // --- Houve alguma instabilidade ao recuperar o PAYLOAD do SOS-SELECT

      if (!!optionPayload === false) {
        return this.showMessage("Atenção!", "Houve alguma instabilidade ao selecionar a escala. Tente novamente!")
      }

      // --- Recupera CARGA ÚTIL da escala selecionada no SOS-SELECT

      const uid = optionPayload.userID
      const userName = optionPayload.userName
      const scaleID = optionPayload.scaleID
      const checked = optionPayload.checked

      // --- Não pode executar enquanto outro carregamento estiver em andamento

      if (this.usersLoadingStatus[uid] === true || this.actionLoading === true) {
        return this.showMessage("Atenção!", `Outra operação está em andamento e você não pode gerenciar as escalas de <b style="color: indianred">${userName}</b>...`)
      }

      // --- Executa o endpoint

      this.actionLoading = true
      this.$set(this.usersLoadingStatus, uid, true)

      // Add or remove userID from RELATED USERS LIST in THE SELECTED SCALE
      // const newUsers = checked === true ? [...foundScale.scaleRelatedUsers, uid] : foundScale.scaleRelatedUsers.filter(relatedUserID => relatedUserID !== uid)

      // Se checked = true, o usuário está selecionado e queremos desvincular (action = remove)
      // Se checked = false, o usuário não está selecionado e queremos vincular (action = add)
      const action = checked ? "remove" : "add"

      let response
      if (action === "add") {
        response = await apiAttachScaleToGroupUser(this.$route.params.groupID, uid, scaleID)
        // console.log("::: apiAttachScaleToGroupUser:", { groupID: this.$route.params.groupID, scaleID, uid }, response)
      } else {
        response = await apiDetachScaleFromGroupUser(this.$route.params.groupID, uid, scaleID)
        // console.log("::: apiDetachScaleFromGroupUser:", { groupID: this.$route.params.groupID, scaleID, uid }, response)
      }

      this.$set(this.usersLoadingStatus, uid, false)
      this.actionLoading = false

      // --- Recarrega a lista em caso de sucesso

      if (response.httpCode === 200)
      {
        // Não é necessário agora, pois a lista de escalas vem de um LISTENER (TEMPO REAL)
        // E a alteração no banco é suficiente para o groupScales provocar um recálculo do preparedUsers

        // this.reloadUsers({ page: this.currentPage, search: this.searchQuery })
      }

      // --- Mostra a resposta do back-end independente do resultado

      this.showMessage(response.title, response.message)
    },

    requestGroupUsersReport ()
    {
      this.$refs.exportGroupUsersModal.open(`${reportUrl}/reports/groupusers_stream/${this.$route.params.groupID}`)
    },

    handleInviteByEmail ()
    {
      this.$router.push({
        path: `/admin/grupos/${this.$route.params.groupID}/convidar`,
        query: { etapa: 'email' }
      })
    },

    handleInviteByLink ()
    {
      this.$router.push({
        path: `/admin/grupos/${this.$route.params.groupID}/convidar`,
        query: { etapa: 'link' }
      })
    },

    closeWorkingHoursModal() {
      this.workingHoursModal = {
        active: false,
        level: null,
        entityId: null,
      }
    },

    openModalForNewRule() {
      this.workingHoursModal = {
        active: true,
        level: null,
        entityId: null,
        groupId: this.$route.params.groupID,
        scaleId: null,
      }
    },

    getScaleName (scaleID) {
      const foundScale = this.groupScales.find(groupScale => groupScale.scaleID === scaleID)
      if (!!foundScale === true) {
        return foundScale.scaleName
      }
      return ''
    },

    getUserName (userID) {
      const foundUser = this.groupUsers.find(groupUser => groupUser.userID === userID)
      if (!!foundUser === true) {
        return foundUser.userName
      }
      return ''
    },

    getWorkingHoursLevelLabel (level) {
      return RULE_LEVEL_LABELS[level] || ''
    },

    getWorkingHoursTypeLabel (level) {
      return RULE_TYPE_LABELS[level] || ''
    },

    getWorkingHoursActionLabel (action) {
      return RULE_ACTION_LABELS[action] || ''
    },

    getWorkingHoursFormattedValue (rule) {
      let interval = 'hora'
      if (rule.type === RULE_TYPE_MAX_CONSECUTIVE_WORK_DAYS.value) {
        interval = 'dia'
      }
      const value = rule.value || 0
      return `${rule.value} ${interval}${value > 1 ? 's' : ''}`
    },

    editWorkingHoursRule(rule) {
      this.workingHoursModal = {
        active: true,
        groupId: this.$route.params.groupID,
        level: rule.level,
        type: rule.type,
        entityId: rule.entity_id,
        scaleId: rule.scale_id,
        value: rule.value,
        action: rule.action,
      }
    },

    confirmDeleteWorkingHoursRule(rule) {
      this.$root.$emit("showMessage", {
        title: "Confirmar",
        message: "Tem certeza que deseja remover esta regra? Essa ação é irreversível.",
        type: "confirm",
        callback: (confirmed) => {
          if (confirmed) this.deleteRule(rule.id)
        },
      });
    },

    async deleteRule(id) {
      try {
        await this.deleteWorkingHoursRule({ id })
        this.getWorkingHoursRulesByGroup(this.$route.params.groupID)
        this.showMessage("Sucesso", "Regra removida com sucesso!")
      } catch (error) {
        // console.error(error)
        this.showMessage("Erro", "Não foi possível apagar a regra.")
      }
    },

    /*
    // [staging-portaltelemedicina / master-portaltelemedicina]
    //
    //
    //
    //
    //
    //
    // --- Gerencia modal responsável por ADICIONAR ou REMOVER MUNICÍPIO de um usuário
    //
    //
    //
    //
    //
    //

    // onMunicipalitySelect (optionValue, optionText, optionPayload)
    // {
    //   console.log('::: onMunicipalitySelect:', { optionValue, optionText, optionPayload })
    // },

    onOpenMunicipalityModal(userItem)
    {
      // --- Não pode executar enquanto outro carregamento estiver em andamento

      if (this.usersLoadingStatus[userItem.userID] === true || this.actionLoading === true) {
        // return this.showMessage("Atenção!", `O sistema está ocupado e você não pode gerenciar os municípios de <b style="color: indianred">${userItem.userName}</b> agora...`)
        return
      }

      // --- Abre o modal de municípios do usuário escolhido

      this.$refs.municipalityModal.open({
        users: this.groupMunicipalities,
        attachedMunicipalities: userItem.userMunicipalities ? Object.keys(userItem.userMunicipalities) : [],
        targetUserID: userItem.userID || "",
        targetUserName: userItem.userName || "[ERRO]",
      })
    },

    async onMunicipalityModalClosed({ reason, payload })
    {
      console.log('[Group/script.js] AttachMunicipalityToUserModal closed:', reason, payload)

      if (["add", "remove"].includes(reason))
      {
        // --- Não pode executar enquanto outro carregamento estiver em andamento

        if (this.usersLoadingStatus[payload.targetUserID] === true || this.actionLoading === true) {
          return this.showMessage("Atenção!", `O sistema está ocupado e você não pode ${reason === "add" ? "atribuir" : "desvincular"} o município de <b style="color: indianred">${payload.targetUserName}</b> agora...`)
        }

        // --- Executa o endpoint

        this.actionLoading = true
        this.$set(this.usersLoadingStatus, payload.targetUserID, true)

        const response = reason === "add" ? (
          await apiAttachMunicipalityToGroupUser(this.$route.params.groupID, payload.targetUserID, payload.municipalityID)
        ) : (
          await apiDettachMunicipalityFromGroupUser(this.$route.params.groupID, payload.targetUserID, payload.municipalityID)
        )

        this.$set(this.usersLoadingStatus, payload.targetUserID, false)
        this.actionLoading = false

        // --- Recarrega a lista em caso de sucesso

        if (response.httpCode === 200) {
          this.reloadUsers({ page: this.currentPage, search: this.searchQuery })
        }

        // --- Mostra a resposta do back-end independente do resultado

        this.showMessage(response.title, response.message)
      }
    },
    // [staging-portaltelemedicina / master-portaltelemedicina]
    */
  },
}
